import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css";
import logo from "../assets/images/logo.jpeg";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => setIsOpen(!isOpen);
  const closeSidebar = () => setIsOpen(false);

  return (
    <>
      {/* ======= Top Navbar (Unchanged) ======= */}
      <nav className="w3-hide navbar">
        <div className="navbar-container">
          <div
            className="navbar-logo"
            onClick={() => (window.location.href = "/")}
          >
            <img src={logo} alt="Logo" />
          </div>

          <ul className="w3-hide nav-links">
            <li>
              <NavLink to="/home" className={({ isActive }) => (isActive ? "active-link" : "")}>
                Home
              </NavLink>
            </li>
          </ul>

          {/* Hamburger Icon (for mobile) */}
          <div className="menu-icon" onClick={toggleSidebar}>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
          </div>
        </div>
      </nav>

      {/* ======= Sidebar ======= */}
      <div
        className={`w3-sidebar w3-bar-block w3-black w3-animate-right ${
          isOpen ? "w3-show" : "w3-hide"
        }`}
        style={{
          width: "250px",
          right: 0,
          top: 0,
          height: "100%",
          position: "fixed",
          zIndex: 1201,
        }}
      >
        <button
          onClick={closeSidebar}
          className="w3-bar-item w3-button w3-large w3-right-align"
        >
          ✕
        </button>
        <NavLink to="/home" onClick={closeSidebar} className="w3-bar-item w3-button">Home</NavLink>
        <NavLink to="/services" onClick={closeSidebar} className="w3-bar-item w3-button">What we do</NavLink>
        <NavLink to="/aboutus" onClick={closeSidebar} className="w3-bar-item w3-button">Who we are</NavLink>
        <NavLink to="/projects" onClick={closeSidebar} className="w3-bar-item w3-button">Projects</NavLink>
        <NavLink to="/workwithus" onClick={closeSidebar} className="w3-bar-item w3-button">Work With Us</NavLink>
        <NavLink to="/partners" onClick={closeSidebar} className="w3-bar-item w3-button">Partners</NavLink>
        <NavLink to="/contact" onClick={closeSidebar} className="w3-bar-item w3-button">Get in touch</NavLink>
      </div>

      {/* ======= Overlay ======= */}
      {isOpen && (
        <div
          className="sidebar-overlay"
          onClick={closeSidebar}
        ></div>
      )}
    </>
  );
}

export default Navbar;
